/* eslint-disable */
import { useState } from 'react';
import { connect } from "react-redux";
import { RefreshCcw, X } from 'lucide-react';
import BaseModal from "../BaseModal/BaseModal";
import { modalActions } from "@/Actions";

function QcApprovalModal(props) {
    const { show, data, toggleQualityApprovalModal } = props;
    const { storeName, vendorName } = data ?? {};
    const isReject = data?.mode === 'reject';
    const showQcIdInput = !isReject && !data?.hideQcId;
    const [qcId, setQcId] = useState(null);
    const [comment, setComment] = useState('');

    const handleClose = () => {
        setQcId(null);
        setComment('');
        toggleQualityApprovalModal(false);
    };

    const handleConfirm = () => {
        if (!comment?.trim()) return;
        if (data?.handleConfirm) {
            data?.handleConfirm(qcId, comment.trim());
        }
        handleClose();
    }

    const handleAutoGenerate = () => {
        const storeCode = storeName?.slice(0, 3).toUpperCase() || 'STR';
        const vendorCode = vendorName?.slice(0, 3).toUpperCase() || 'VEN';

      const date = new Date();
      const dateStr =
        date.getDate().toString().padStart(2, '0') +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        date.getFullYear();

      // Generate random 4 digits
      const randomDigits = Math.floor(Math.random() * 9000 + 1000);

      const newQcId = `${storeCode}-${vendorCode}-${dateStr}-${randomDigits}`;
      setQcId(newQcId);
    };

    const renderBtns = () => {
        return (
            <div className="flex w-full justify-end ">
                <button
                    onClick={handleClose}
                    className="w-1/2 px-4 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
                >
                    Cancel
                </button>
                <button
                    onClick={handleConfirm}
                    disabled={!comment?.trim()}
                    className={`w-1/2 px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${isReject
                        ? 'bg-red-500 text-white hover:bg-red-600'
                        : 'bg-yellow-500 text-black hover:bg-yellow-600'}`}
                >
                    {isReject ? 'Reject QC' : 'Approve QC'}
                </button>
            </div>
        )
    }
    return (
        <BaseModal
            open={show}
            handleClose={handleClose}
            renderBtns={renderBtns}
            height={data?.height ?? 'fit-content'}
            width='400px'
        >
            <div className='p-6 space-y-4'>
                {showQcIdInput ? (
                    <>
                        <div className='h-auto w-auto flex justify-between items-start gap-4'>
                            <h2 className="text-xl font-semibold">Enter QC ID to complete.</h2>
                            <div
                                onClick={handleAutoGenerate}
                                className="flex justify-center items-center gap-2 text-blue-600 bg-blue-200 hover:bg-slate-200 rounded-md p-1"
                            >
                               <RefreshCcw className='w-4 h-4' />  Auto Generate
                            </div>
                        </div>

                        <input
                            type="text"
                            value={qcId}
                            onChange={(e) => setQcId(e.target.value)}
                            placeholder="Enter QC ID"
                            className="w-full border border-gray-300 rounded-md p-2"
                        />
                    </>
                ) : (
                    <h2 className="text-xl font-semibold">
                        {isReject ? 'Reject QC' : 'Approve QC'}
                    </h2>
                )}
                <div className='space-y-1'>
                    <label className='text-sm font-medium text-gray-700'>
                        Reason <span className='text-red-500'>*</span>
                    </label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder={isReject ? 'Reason for rejecting this QC' : 'Reason for approving this QC'}
                        rows={3}
                        className="w-full border border-gray-300 rounded-md p-2 resize-none text-sm"
                    />
                </div>
            </div>
        </BaseModal>
    );
}

const mapStateToProps = (state) => {
    const { qualityApprovalModal = { show: false, data: {} } } = state.modal;
    return {
        show: qualityApprovalModal.show,
        data: qualityApprovalModal.data,
    };
};

const mapDispatchToProps = {
    toggleQualityApprovalModal: modalActions.toggleQualityApprovalModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(QcApprovalModal);
